import { Action, Reducer } from 'redux';
import {
  ApprovalMatrixTypeState,
  ApprovalMatrixTypeTypes,
  ApprovalMatrixTypeActionTypes
} from './approvalMatrixTypeTypes';

export const INITIAL_STATE: ApprovalMatrixTypeState = {
  approvalMatrixType: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  }
};

const approvalMatrixTypeReducer: Reducer<ApprovalMatrixTypeState> = (
  state: ApprovalMatrixTypeState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as ApprovalMatrixTypeActionTypes;

  switch (actionTypes.type) {
    case ApprovalMatrixTypeTypes.GET_APPROVAL_MATRIX_TYPE:
      return {
        ...state,
        approvalMatrixType: {
          ...state.approvalMatrixType,
          isLoading: true
        }
      };

    case ApprovalMatrixTypeTypes.SAVE_APPROVAL_MATRIX_TYPE:
      return {
        ...state,
        approvalMatrixType: {
          ...state.approvalMatrixType,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };

    case ApprovalMatrixTypeTypes.RESET_REDUCER_APPROVAL_MATRIX_TYPE:
      return {
        ...state,
        approvalMatrixType: INITIAL_STATE.approvalMatrixType
      };

    default:
      return state;
  }
};

export default approvalMatrixTypeReducer;